module.exports = __webpack_public_path__ + "static/media/electricrevolution.a674f559.pdf";